import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import './index.scss';

const AcceptTermsModal = ({ show, onClose, history }) => {
  const [accepted, setAccepted] = React.useState(false);

  function toLoggedArea() {
    history.push('/');
  }

  function resetState() {
    setAccepted(false);
  }

  return (
    <Dialog
      className="modal-accept-term"
      open={show}
      onClose={() => {
        onClose();
        resetState();
      }}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle
        id="scroll-dialog-title"
        style={{
          textAlign: 'center',
          color: '#1B365D',
          fontWeight: 600,
          fontSize: 16
        }}
      >
        Termo de Aceite SulAmérica
        <br />
        <span style={{ fontWeight: 400 }}>Prestador Odonto</span>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
          <div className="accept-term-container">
            <p className="flow-text italic-text">Prezado Prestador,</p>
            <p className="flow-text italic-text">
              Disponibilizamos para sua utilização o
              <strong> SulAmérica Prestador Odonto </strong>.
            </p>
            <p className="flow-text italic-text">
              Neste canal é possível verificar a elegibilidade dos Beneficiários, solicitar e
              consultar Guia de Tratamento Odontológico (GTO) , encaminhar as mesmas para
              faturamento , anexar imagens e realizar recursos em conformidade com as regras
              regulatórias da ANS (Agência Nacional de Saúde Suplementar).
            </p>
            <p className="flow-text italic-text">
              Ao utilizar este novo canal, o prestador se torna responsável exclusivo pelas
              informações, documentos encaminhados e pela guarda da documentação original.
            </p>
            <p className="flow-text">*</p>
            <p className="flow-text italic-text bold-text">
              A qualquer momento, a SulAmérica poderá solicitar e verificar as informações e
              documentações originais, sendo certo que a falta de encaminhamento ou divergência de
              informações destas poderá acarretar o não pagamento ao prestador.
            </p>
            <p className="flow-text">
              Li e concordo com as informações acima e comprometo-me com a veracidade das
              informações transmitidas, bem como a guardar e fornecer os prontuários do
              beneficiário quando solicitado pela Operadora.
            </p>
            <FormControlLabel
              control={
                <Checkbox checked={accepted} onChange={() => setAccepted(!accepted)} style={{ color: '#DC6B2F' }} />
              }
              label="Aceito os termos de uso"
            />
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onClose();
            resetState();
          }}
        >
          Cancelar
        </Button>
        <Button
          onClick={toLoggedArea}
          className="btn-entrar"
          style={{ fontWeight: 600 }}
          disabled={!accepted}
        >
          Entrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AcceptTermsModal;
